// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._148JkFxV2zx9RE {\n  position: absolute;\n  height: 64px;\n  width: 64px;\n  transition: transform 85ms ease-in, opacity 85ms ease-in;\n  -webkit-user-select: none;\n          user-select: none;\n}\n._3Pq4xeRMbFO8E2 {\n  height: 64px;\n  width: 64px;\n  color: transparent;\n  border: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sticker": "_148JkFxV2zx9RE",
	"stickerImage": "_3Pq4xeRMbFO8E2"
};
export default ___CSS_LOADER_EXPORT___;
